import { Typography } from "@material-ui/core";
import React from "react";

const Container = ({ children, title, style }) => {

    return (
        <div
            style={{
                background: "var(--tertiaryBackgroundColor)",
                border: "1px solid var(--borderColor)",
                borderRadius: 15,
                padding: 15,
                ...style,
            }}
        >
            {
                title &&
                <Typography
                    style={{
                        width: "100%",
                        fontSize: 18,
                        fontWeight: 600,
                        paddingBottom: 5,
                        marginBottom: 10,
                        borderBottom: "1px solid var(--borderColor)",
                    }}
                >
                    {title}
                </Typography>
            }
            {children}
        </div>
    );
}

export default Container;